
import { Competitor, Side } from 'smartstream-widgets/types/competitor'

export function findCompetitorBySide<T extends Competitor>(competitors: Array<T>, side: Side): T {
  return competitors.find((competitor, index) => {
    if (competitor.homeOrAway) return competitor.homeOrAway === side
    return (side === 'HOME' && index === 0) || (side === 'AWAY' && index === 1)
  })
}
